<template>
<header class="header_sticky">
    <div  :class="fullwidth ? 'container-fluid' : 'container'">
        <div class="row">
            <div class="col-lg-5 col-10">
                <div id="logo_home">
                    <h1>
                        <router-link tag="a" :to="'/'" >
                        DoctorConsultas
                        </router-link>
                        <div class="flag-uy"></div>
                    </h1>
                </div>
            </div>
            <nav class="col-lg-7 col-2">
               
                <div class="cmn-toggle-switch " @click="isOpen =! isOpen"><span>Menu mobile</span></div>
                
                <!-- <ul id="top_access" v-else>
                    <li><a href="#/account"><i class="pe-7s-user"></i></a></li>
                    <li><a href="#/login"><i class="pe-7s-add-user"></i></a></li>
                </ul> -->
                <div class="main-menu" :class="{'show':isOpen}">
                    <ul>
                        <li><router-link tag="a" :to="'/'">Inicio</router-link></li>
                        <li><router-link tag="a" :to="'/about'">Quienes somos</router-link></li>
                        <!-- <li><router-link tag="a" :to="'/faqs'">FAQs</router-link></li> -->
                        <li><router-link tag="a" :to="'/contact'">Contacto</router-link></li>
                        <li><router-link tag="a" :to="'/register'"  v-if="!isAuthenticated && $route.name=='login'" >Registrarme</router-link></li>
                        
                        <!-- <li><router-link tag="a" :to="'/login'"  v-if="!isAuthenticated && $route.name!='login'" >Ingresar</router-link></li> -->
                        <li class="submenu" v-if="!isAuthenticated && $route.name!='login'">
                            <a href="#">Ingresar</a>
                            <ul>
                                <li><router-link tag="a" :to="'/login'"  >Pacientes</router-link></li>
                                <li><a href="https://medicos.doctorconsultas.com/login">Médicos</a></li>
                                <li><a href="https://clinicas.doctorconsultas.com/login">Clinicas</a></li>                                
                            </ul>
                        </li>

                        <li class="submenu" v-if="isAuthenticated && loggedUser">
                            <router-link tag="a" :to="'/profile'" class="show-submenu">
                                <div class="profile-picture">
                                    <div class="avatar" v-if="loggedUser.picture" :style="'background-image:url('+API_URL+loggedUser.picture.urlThumb+')'"></div>
                                    <div class="avatar" v-else :style="'background-image:url('+require('@/assets/img/no-avatar-image-thumb.gif')+')'"></div>
                                </div>
                                {{loggedUser.fullname}} <i class="icon-down-open-mini"></i>
                            </router-link>
                            <ul>
                                <li><router-link tag="a" :to="'/profile'">Mi perfil</router-link></li>
                                <li><router-link tag="a" :to="'/bookings'" >Mis reservas</router-link></li>
                                <li><router-link tag="a" :to="'/clinic-services'" >Mis exámenes</router-link></li>
                                <li><router-link tag="a" :to="'/logout'" >Salir</router-link></li>
                                
                            </ul>
                        </li>
                        <li v-if="$installer.canInstall">
                            <div class="installer-button"  @click="$installer.prompt">
                                <span>Instalar en dispositivo</span>
                            </div>
                            
                        </li>
                    </ul>
                </div>
                <!-- /main-menu -->
            </nav>
        </div>
    </div>
    <ComingChat/>
</header>
</template>

<script>
import { mapGetters } from 'vuex'
import ComingChat from '@/components/ComingChat'

export default {
    name: "Navigation",
    props:['fullwidth'],
    components:{
        ComingChat
    },
    computed: {
		...mapGetters(['isAuthenticated','loggedUser'])
    },
    data(){
        return{
            isOpen:false,
            API_URL: process.env.VUE_APP_API_URL
        }
    }
};
</script>

<style scoped>
header {
    background-color: #fff;
    height: 56px;
    border-bottom: 1px solid transparent;
}

header.header_sticky {
    width: 100%;
    z-index: 999;
    position: relative;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

header.header_sticky.sticky {
    border-bottom: 1px solid #ededed;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
}

header.header_map {
    width: 100%;
    border-bottom: 1px solid #ededed;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
}

header.static {
    position: static;
    border-bottom: 1px solid #ededed;
    z-index: 999;
    position: relative;
}



.show-submenu .profile-picture {
    width: 35px;
    height: 35px;
    overflow: hidden;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    border-radius: 50%;
    margin-right: 8px;    
}
.show-submenu .profile-picture .avatar{

}



/* logo home with h1 */
#logo_home h1 {
    margin: 0;
    padding: 0;
    line-height: 1;
    display: flex;
    align-items: center;
}

#logo_home h1 a {
    display: block;
    background: url(../assets/img/logo.png);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover; 
    width: 300px;
    background-size: contain;
    text-indent: -9999px;
    margin-top: 8px;
}

@media only screen and (min--moz-device-pixel-ratio: 2),
only screen and (-o-min-device-pixel-ratio: 2 / 1),
only screen and (-webkit-min-device-pixel-ratio: 2),
only screen and (min-device-pixel-ratio: 2) {
    #logo_home h1 a {
        background-image: url(../assets/img/logo_2x.png);
        width: 100%;
    }
}

.flag-uy{
    background: url(../assets/img/uruguay-flag-icon.png);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover; 
    width: 20px;
    height: 14px;
    margin-top: 13px;
    margin-left: 4px;
    background-size: contain; 
}
.main-menu {
    position: relative;
    z-index: 9;
    width: auto;
    top: 7px;
    float: right;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}
.main-menu ul{
    display: flex;
    align-items:center;
}

.main-menu ul,
.main-menu ul li {
    position: relative;
    margin: 0;
    padding: 0;
}


/*First level styles */
.main-menu>ul>li>a {
    color: #333;
    padding: 0 8px 0px 8px;
    height: 48px;
    font-size: 14px;
    font-size: 0.875rem;
    font-weight: 500;
    display: flex;
    align-items: center;
}

.main-menu>ul>li:hover>a {
    color: #12bcec;
}


/* Opacity mask when left open */
.layer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    min-width: 100%;
    z-index: 100;
    min-height: 100%;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.8);
    -webkit-transition: transform 0.3s ease 0s, opacity 0.3s ease 0s,
        visibility 0s ease 0.3s;
    -moz-transition: transform 0.3s ease 0s, opacity 0.3s ease 0s,
        visibility 0s ease 0.3s;
    -ms-transition: transform 0.3s ease 0s, opacity 0.3s ease 0s,
        visibility 0s ease 0.3s;
    -o-transition: transform 0.3s ease 0s, opacity 0.3s ease 0s,
        visibility 0s ease 0.3s;
    transition: transform 0.3s ease 0s, opacity 0.3s ease 0s,
        visibility 0s ease 0.3s;
    opacity: 0;
    visibility: hidden;
}

.layer-is-visible {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.3s ease 0s, transform 0.3s ease 0s;
    -moz-transition: opacity 0.3s ease 0s, transform 0.3s ease 0s;
    -ms-transition: opacity 0.3s ease 0s, transform 0.3s ease 0s;
    -o-transition: opacity 0.3s ease 0s, transform 0.3s ease 0s;
    transition: opacity 0.3s ease 0s, transform 0.3s ease 0s;
}

#close_in,
#header_menu,
.cmn-toggle-switch {
    display: none;
    cursor: pointer;
}

/* All styles for screen size over 992px
================================================== */
@media only screen and (min-width: 992px) {
    .main-menu {
        width: auto;
    }

    .main-menu a {
        white-space: nowrap;
    }

    .main-menu ul li {
        display: inline-block;
    }

    .main-menu ul li.submenu:hover>a:before,
    .main-menu ul li.submenu:hover>a:after {
        bottom: -10px;
        opacity: 0;
    }

    /* Submenu*/
    .main-menu ul ul,
    .main-menu ul li .menu-wrapper {
        position: absolute;
        border-top: 2px solid #12bcec;
        z-index: 1;
        visibility: hidden;
        left: 3px;
        top: 100%;
        margin: 0;
        display: block;
        padding: 0;
        background: #fff;
        min-width: 210px;
        -webkit-box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.175);
        -moz-box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.175);
        box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.175);
        -webkit-transform: translateY(20px);
        -moz-transform: translateY(20px);
        -ms-transform: translateY(20px);
        -o-transform: translateY(20px);
        transform: translateY(20px);
        opacity: 0;
        -moz-transition: all 0.2s ease;
        -o-transition: all 0.2s ease;
        -webkit-transition: all 0.2s ease;
        -ms-transition: all 0.2s ease;
        transition: all 0.2s ease;
    }

    .main-menu ul li .menu-wrapper {
        padding: 10px 15px !important;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .main-menu ul li:hover>ul,
    .main-menu ul li:hover .menu-wrapper {
        padding: 0;
        visibility: visible;
        -webkit-transform: translateY(0);
        -moz-transform: translateY(0);
        -ms-transform: translateY(0);
        -o-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }

    .main-menu ul .menu-wrapper ul {
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        border-top: none;
        margin: 0;
        position: static;
        -webkit-transform: translateY(0);
        -moz-transform: translateY(0);
        -ms-transform: translateY(0);
        -o-transform: translateY(0);
        transform: translateY(0);
    }

    .main-menu ul .menu-wrapper ul:before {
        border: 0;
    }

    .main-menu ul ul li {
        display: block;
        height: auto;
        padding: 0;
    }

    .main-menu ul ul li a {
        font-size: 13px;
        font-size: 0.8125rem;
        color: #555;
        border-bottom: 1px solid #ededed;
        display: block;
        padding: 15px;
        -moz-transition: all 0.3s ease;
        -o-transition: all 0.3s ease;
        -webkit-transition: all 0.3s ease;
        -ms-transition: all 0.3s ease;
        transition: all 0.3s ease;
    }

    .main-menu ul ul li:last-child a {
        border-bottom: none;
    }

    .main-menu ul ul li:hover>a {
        background-color: #f9f9f9;
        color: #12bcec;
        padding-left: 18px;
    }

    /* Submenu 3rd level v.1.4 */
    .main-menu ul ul ul {
        position: absolute;
        border-top: 0;
        z-index: 1;
        height: auto;
        left: 100%;
        top: 0;
        margin: 0;
        padding: 0;
        background: #fff;
        min-width: 190px;
        -webkit-box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.175);
        -moz-box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.175);
        box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.175);
    }

    .installer-button{
    
        display: none !important;
    }
}

@media only screen and (max-width: 991px) {

    .main-menu ul li a:hover,
    a.show-submenu:hover,
    a.show-submenu:focus,
    a.show-submenu-mega:hover,
    a.show-submenu-mega:focus {
        color: #12bcec !important;
        background-color: #f9f9f9;
    }

    .main-menu ul li {
        border-top: none;
        border-bottom: 1px solid #ededed;
        color: #fff;
    }

    /* Menu mobile first level */
    .main-menu ul li a {
        padding: 15px !important;
    }

    .main-menu li,
    .main-menu a {
        display: block;
        color: #333 !important;
    }

    .main-menu li {
        position: relative;
    }

    .main-menu a:hover {
        color: #12bcec !important;
    }

    .main-menu ul>li {
        padding-bottom: 0;
    }

    .main-menu ul>li i {
        float: right;
    }

    /* Menu mobile second level */
    .main-menu ul li.submenu .show-submenu i{
        display: none;
    }
    .main-menu ul li.submenu ul {
        /* border-left: 1px solid #ededed;
        margin: 0 0 10px 25px; */
    }

    
    

    .main-menu ul li.submenu ul li {
        border: 0;
    }

    /* Menu mobile 3rd level */
    .main-menu ul li.submenu ul ul {
        border-left: none;
        margin: 0 0 0 15px;
    }

    /* Menu mobile left panel */
    .main-menu {
        overflow-y: auto;
        padding-bottom: 60px;
        transform: translateX(-102%);
        top: 56px;
        border-top: 1px solid #ededed;
        border-right: 1px solid #ededed;
        left: 0;
        bottom: 0;
        width: 240px;
        height: calc(100% - 56px);
        position: fixed;
        background-color: #fff;
        -webkit-transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);
        -moz-transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);
        -ms-transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);
        -o-transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);
        transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);

    }
    .main-menu ul{
        display: block;

    }

   

    .main-menu.show {
        transform: translateX(0);
    }

    .main-menu .show-submenu+ul,
    a.show-submenu-mega+.menu-wrapper {
        /* display: none;
        visibility: hidden; */
    }

    a.show-submenu-mega+.menu-wrapper.show_mega,
    .main-menu a.show-submenu+ul.show_normal {
        display: block;
        visibility: visible;
    }

    /* Hamburger menu button*/
    .cmn-toggle-switch {
        position: relative;
        display: block;
        overflow: visible;
        position: absolute;
        top: 17px;
        right: 15px;
        margin: 0;
        padding: 0;
        width: 30px;
        height: 30px;
        font-size: 0;
        text-indent: -9999px;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        box-shadow: none;
        border: none;
        cursor: pointer;
    }

    .cmn-toggle-switch:focus {
        outline: none;
    }

    .cmn-toggle-switch span {
        display: block;
        position: absolute;
        top: 10px;
        left: 0;
        right: 0;
        height: 2px;
        background: #333;
    }

    .cmn-toggle-switch span::before,
    .cmn-toggle-switch span::after {
        position: absolute;
        display: block;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #333;
        content: "";
    }

    .cmn-toggle-switch span::before {
        top: -10px;
    }

    .cmn-toggle-switch span::after {
        bottom: -10px;
    }

    .cmn-toggle-switch__htx span::before,
    .cmn-toggle-switch__htx span::after {
        -webkit-transition-duration: 0.3s, 0.3s;
        transition-duration: 0.3s, 0.3s;
        -webkit-transition-delay: 0.3s, 0;
        transition-delay: 0.3s, 0;
    }

    .cmn-toggle-switch__htx span::before {
        -webkit-transition-property: top, -webkit-transform;
        transition-property: top, transform;
    }

    .cmn-toggle-switch__htx span::after {
        -webkit-transition-property: bottom, -webkit-transform;
        transition-property: bottom, transform;
    }

    /* active state, i.e. menu open */
    .cmn-toggle-switch__htx.active span {
        background: none !important;
    }

    .cmn-toggle-switch__htx.active span::before {
        top: 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .cmn-toggle-switch__htx.active span::after {
        bottom: 0;
        -webkit-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        transform: rotate(-45deg);
    }

    .cmn-toggle-switch__htx.active span::before,
    .cmn-toggle-switch__htx.active span::after {
        -webkit-transition-delay: 0, 0.3s;
        transition-delay: 0, 0.3s;
    }
}

@media only screen and (max-width: 480px) {
    .main-menu {
        width: 100%;
    }
}


.installer-button{
    color: #333;
    padding: 15px !important;
    height: 48px;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
}

</style>
